/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * type of message sent
 * @export
 */
export const MessageCategory = {
    TipsTrick: 'TIPS_TRICK',
    Support: 'SUPPORT',
    Personal: 'PERSONAL',
    Innovations: 'INNOVATIONS',
    SuccessStory: 'SUCCESS_STORY',
    Prospect: 'PROSPECT',
    Promotion: 'PROMOTION'
} as const;
export type MessageCategory = typeof MessageCategory[keyof typeof MessageCategory];


export function MessageCategoryFromJSON(json: any): MessageCategory {
    return MessageCategoryFromJSONTyped(json, false);
}

export function MessageCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageCategory {
    return json as MessageCategory;
}

export function MessageCategoryToJSON(value?: MessageCategory | null): any {
    return value as any;
}

